import { ISupportCase } from '../index';

export interface ICard {
    id: string;
    code: string;
    supportCases?: ISupportCase[];
}

export enum LinkCardOption {
    NEW_CARD = 'new',
    EXISTING_CARD = 'existing',
}
